<template>
	<div>

				



		<mdb-row>
			<mdb-col md="4" style="margin-bottom: 10px;">
				<div class="form__group">
					<label for="pais" class="form__label">Marca:</label>
					<select v-model="brand" class="browser-default custom-select">
						<option selected>Selecciona una opción</option>
							<option v-for="(brand, index) in brandsArray" :key="index" :value="brand">{{ brand }}</option>
					</select>
					 <validation-error :validation="$v.brand" />
				</div>
			</mdb-col>
			<mdb-col md="4" style="margin-bottom: 10px;">
				<div class="form__group">
					<div class="form__group">
						<label class="form__label">Modelo:</label>
						<input type="text" v-model="model"  class="form__input" value="" />
					</div>
					<validation-error :validation="$v.model" />
                    
				</div>
			</mdb-col>
		</mdb-row>

		<mdb-row>
			<mdb-col md="4" style="margin-bottom: 10px;">
				<div class="form__group">
					<label  class="form__label">Año:</label>
						<select v-model="year" class="browser-default custom-select">
							<option selected>Selecciona una opción</option>
							<option v-for="(year, index) in yearsArray" :key="index" :value="year">{{ year }}</option>
						</select>
				</div>
				<validation-error :validation="$v.year" />
			</mdb-col>
		</mdb-row>

			<mdb-row>
			<mdb-col md="4" style="margin-bottom: 10px;">
				<div class="form__group">
					<label  class="form__label">Color:</label>
						<select v-model="color" class="browser-default custom-select">
							<option selected>Selecciona una opción</option>
								<option value="Negro">Negro</option>
								<option value="Blanco">Blanco</option>
								<option value="Rojo">Rojo</option>
								<option value="Azul">Azul</option>
								<option value="Verde">Verde</option>
								<option value="Gris">Gris</option>
								<option value="Amarillo">Amarillo</option>
								<option value="Café">Café</option>
								<option value="Rosa">Rosa</option>
								<option value="Naranja">Naranja</option>
								<option value="Morado">Morado</option>
								<option value="Guinda">Guinda</option>
						</select>
				</div>
				<validation-error :validation="$v.color" />
			</mdb-col>
		</mdb-row>

		<mdb-row>
			<mdb-col md="3" style="margin-bottom: 10px;">
				<div class="form__group">
					<div class="form__group">
						<label class="form__label">Número de placas:</label>
						<input type="text" v-model="plates" class="form__input" value="" />
					</div>
				<validation-error :validation="$v.plates" />

				</div>
			</mdb-col>
		</mdb-row>

        	<mdb-row class="mt-4">
				<mdb-col md="6">
					<label for="buttonUploadAuto" class="form__label">Sube la factura de tu  vehículo en formato PDF:</label>
					<div v-show="pdfUrlAuto==null" class="curp-upload">

					<label :for="'autoCount'+index" class="btn-label">
					<img :src="'../../img/icons/'+uploadIcon" style="width: 20px;" />
					SUBIR FACTURA
					</label>

					<input type="file" ref="uploadFileInput" accept="application/pdf" name="file" :id="'autoCount'+index" @change="uploadAuto" />
					<validation-error :validation="$v.pdfUrlAuto" />

					<!--<validation-error :validation="$v.singleRe.worker"></validation-error>-->
					</div>
					<div v-show="pdfUrlAuto!=null" class="input-group">
						<btn
							:text="'¡LISTO!'"
							:type="'primary-admin-success'"
							style="float:left;"
						></btn>

						<img
							style="margin-top: 10px; cursor: pointer;"
							:src="'/img/icons/'+watchButton"
							@click="viewPdfAuto(pdfUrlAuto)"
							@mouseup="mouseUpIcon('watch')"
							@mousedown="mouseDownIcon('watch')"
							@mouseleave="mouseLeaveIcon('watch')"
						/>
					</div>
					</mdb-col>
					<mdb-col md="6"></mdb-col>

		</mdb-row>

		<!-- <mdb-row>
			<mdb-col md="4" style="margin-bottom: 10px;"></mdb-col>
			<mdb-col md="4" style="margin-bottom: 10px;">
				<div class="form__group">
					<div class="form__group">
						  <Btn type="primary-block2" icon="plus" text="Agregar Auto" class="btn-add-child" @onClick="addAuto" />
					</div>
				</div>
			</mdb-col>
			<mdb-col md="4" style="margin-bottom: 10px;"></mdb-col>
		</mdb-row> -->


		 

         	<Popup size="lg" ref="autoFacturaPopUp" title="Factura del auto">
				<div class="embed-responsive embed-responsive-16by9 z-depth-1-half" style="height: 75vh;">
					<iframe title="titulo" class="embed-responsive-item" :src="popUrlAuto" allowfullscreen></iframe>
				</div>
				<div class="accordion__button">
					<btn
					style="float: left;"
					text="CERRAR"
					@onClick="$refs.autoFacturaPopUp.toggleModal()"
					type="primary-block"
					/>
				</div>
				</Popup>



	</div>
</template>
<script>
	import Btn from '../../core/Button';
	import { mdbContainer, mdbRow, mdbCol } from "mdbvue";
	import { mapActions, mapGetters, mapMutations } from "vuex";
	import { mask } from "vue-the-mask";
	import Popup from "../../core/Popup";
	import vSelect from "vue-select";
	import ValidationError from "../misc/ValidationError";
    import { required, email, minLength, alphaNum, maxLength, sameAs } from "vuelidate/lib/validators";


	export default {
		name: "BeneficiaryAutosData",
		props:["index"],
		components: {
			mdbContainer,
			mdbRow,
			vSelect,
			mdbCol,
			Btn,
			Popup,
			ValidationError,
		},
		data(){
			return {
				brandsArray:[],
				yearsArray:[],
				infoIdIcon: 'info-default.svg',
				"brand":"",
				"model": "",
				"year": "",
				"color": "",
				"plates": "",
                infoIdIcon: 'info-default.svg',
				uploadIcon: "upload-document.svg",
				watchButton: "watch-unpressed-btn.svg",
                pdfUrlAuto: null,
				filesPDFAuto: null,
				popUrlAuto: null,
                arrayAutos:[],
                arrayAutosFiles:[],
				autoCount:"auto-1",
				fullAutosData:[{"autos": []}, {"documents": []}],
				carUp: null,
			}
		},
		validations: {
			brand: {
				required
			},
			model: {
				required
			},
			year: {
				required
			},
			color: {
				required
			},
			plates: {
				required
			},
			pdfUrlAuto:{
				required
			}
		},
		created(){
			this.brandsArray = [
				"Acura",
				"Alfa Romeo",
				"AMC",
				"Aston Martin",
				"Audi",
				"Avanti",
				"Bentley",
				"BMW",
				"Buick",
				"BYD",
				"Cadillac",
				"Chevrolet",
				"Chrysler",
				"Daewoo",
				"Daihatsu",
				"Datsun",
				"DeLorean",
				"Dodge",
				"Eagle",
				"Ferrari",
				"FIAT",
				"Fisker",
				"Ford",
				"Freightliner",
				"Geo",
				"GMC",
				"Honda",
				"Hummer",
				"Hyundai",
				"Infiniti",
				"INEOS",
				"Isuzu",
				"Jaguar",
				"Jeep",
				"Kia",
				"Lamborghini",
				"Lancia",
				"Land Rover",
				"Lexus",
				"Lincoln",
				"Lotus",
				"Maserati",
				"Maybach",
				"Mazda",
				"McLaren",
				"Mercedes-Benz",
				"Mercury",
				"Merkur",
				"MINI",
				"Mitsubishi",
				"Nissan",
				"Oldsmobile",
				"Peugeot",
				"Plymouth",
				"Pontiac",
				"Porsche",
				"RAM",
				"Renault",
				"Rolls-Royce",
				"Saab",
				"Saturn",
				"Scion",
				"smart",
				"SRT",
				"Sterling",
				"Subaru",
				"Suzuki",
				"Tesla",
				"Toyota",
				"Triumph",
				"Volkswagen",
				"Volvo",
				"Yugo",
				"Seat"
				];
      //Para llenar el array de años desde 1950 hasta hoy
			let x = new Date().getFullYear();
      while(x>1949){
          this.yearsArray.push(x);
          x--;
      }
	},
	mounted(){
		 let userAllData = JSON.parse(localStorage.getItem("userAllData"));
		 //console.log(userAllData)
		 if(userAllData.cars.length>0 && this.index<userAllData.cars.length){
			 let documents= userAllData.documents
				this.carUp = userAllData.cars[this.index]
				//console.log(this.carUp)
			

				let factura = documents.filter(function(item){
					return item.documentType == "CAR_BILL"
				})

				this.pdfUrlAuto = factura[this.index].publicURL
				this.brand=this.carUp.brand,
				this.model= this.carUp.model,
				this.year= this.carUp.year
				this.color= this.carUp.color
				this.plates= this.carUp.plates

		 }

	},
	computed: {
		...mapGetters({
			benefName: "getBeneficiaryName",
		}),
		beneficiaryName: {
			get(){
				return this.benefName;
			},
			set(value){
				this.$store.commit("_setName", value);
			}
		}
	},
	methods: {
		chooseFile(){
			document.getElementById("fileUpload").click();
		},
		chooseFileCurp(){
			document.getElementById("fileUploadCurp").click();
		},
		chooseFileColonia(){
			document.getElementById("fileUploadColonia").click();
		},
		chooseFileCartaAntec(){
			document.getElementById("fileUploadCartaAntec").click();
		},
		chooseFileIdentificacion(){
			document.getElementById("fileUploadIdentificacion").click();
		},
		mouseOverIcon(){
			let infoIdIcon = this.infoIdIcon.split("-");
			this.infoIdIcon = `${infoIdIcon[0]}-hover.svg`;
		},
		mouseLeaveIcon(){
			let infoIdIcon = this.infoIdIcon.split("-");
			this.infoIdIcon = `${infoIdIcon[0]}-default.svg`;
		},

        	mouseLeaveIcon(module) {
				if (module == "upload") {
					let uploadIcon = this.uploadIcon.split("-");
					this.uploadIcon = `${uploadIcon[0]}-document.svg`;
				} else if (module == "release") {
					let releaseIcon = this.releaseIcon.split("-");
					this.releaseIcon = `${releaseIcon[0]}-default.svg`;
				} else if (module == "watch") {
					this.watchButton = "watch-unpressed-btn.svg";
				} else {
					let helpIcon = this.helpIcon.split("-");
					this.helpIcon = `${helpIcon[0]}-default.svg`;
					this.showCard = false;
				}
				},
				mouseDownIcon(module) {
					if (module == "upload") {
						let uploadIcon = this.uploadIcon.split("-");
						this.uploadIcon = `${uploadIcon[0]}-document.svg`;
					} else if (module == "watch") {
						this.watchButton = "watch-pressed-btn.svg";
					} else {
						let releaseIcon = this.releaseIcon.split("-");
						this.releaseIcon = `${releaseIcon[0]}-click.svg`;
					}
				},
				mouseUpIcon(module) {
					if (module == "upload") {
						let uploadIcon = this.uploadIcon.split("-");
						this.uploadIcon = `${uploadIcon[0]}-document.svg`;
					} else if (module == "watch") {
						this.watchButton = "watch-unpressed-btn.svg";
					} else {
						let releaseIcon = this.releaseIcon.split("-");
						this.releaseIcon = `${releaseIcon[0]}-hover.svg`;
					}
				},
			viewPdfAuto(url) {
			this.popUrlAuto = url;
			this.$refs.autoFacturaPopUp.toggleModal();
			},
			uploadAuto: function(evt) {
				//console.log("upload Auto.....")
			this.pdfUrlAuto = URL.createObjectURL(evt.target.files[0]);
			let aux = this;
			var rdr = new FileReader();
			rdr.onload = function(e) {
				aux.filesPDFAuto = e.target.result.split(",")[1];
			};
			rdr.readAsDataURL(evt.target.files[0]);
			},

			addAuto(){

				this.$v.$touch();
				if(!this.$v.$invalid || this.carUp != null){
					// this.$notify.success({
					// 	message:
					// 	"Auto agregado",
					// 	position: "bottom right",
					// 	timeOut: 3000
					// });
					
					 
					//  let autosBody = {
					// 	 	brand:this.brand, 
					// 		model:this.model,
					// 		year:this.year,
					// 		color:this.color,
					// 		plates:this.plates,
					// 		facturaAuto: {
					// 	 "documentType": "CAR_BILL",
					// 		"value": this.plates,
					// 		extension: "pdf",
					// 		mimeType: "application/pdf",
					// 		content: this.filesPDFAuto
					//  	}
					//  }

					

					 
            
					this.fullAutosData[0].autos.push({
                            brand:this.brand, 
							model:this.model,
							year:this.year,
							color:this.color,
							plates:this.plates
                    });
					this.fullAutosData[1].documents.push({
                           "documentType": "CAR_BILL",
							"value": this.plates,
							extension: "pdf",
							mimeType: "application/pdf",
							content: this.filesPDFAuto
                    });

                
    

					return this.fullAutosData
				}
				else {
					return false;
				}
				
			},
           
		    getFormdata() {

                
                    //console.log("autos: ",this.fullAutosData[0].autos);
                    //console.log("documentos: ", this.fullAutosData[1].documents);

					if(this.fullAutosData[0].autos.length > 0  && this.fullAutosData[1].documents.length > 0) {
 						return this.fullAutosData;
					}
					
					else{
						return false;
					}
                   
            }



            }
	}
</script>
<style>
	.t1-input-colonia {
		/* max-width: 80%; */
		display: inline;
		transform: translateY(3px);
		margin-bottom: 10px !important; 
	}

	.t1-input-curp {
		display: inline; 
		max-width: 70%; 
		transform: translateY(3px);
	}

	.t1-input-dia,
	.t1-input-mes {
		text-align: center;
		display: inline; 
		width: 8%; 
		margin-right: 15px; 
		transform: translateY(3px);
	}

	.t1-input-ano {
		text-align: center; 
		display: inline; 
		width: 12%; 
		transform: translateY(3px);
	}

	.btn-comprobante-domicilio {
		/* margin-left: 10px; */
		display: inline;
	}

	.btn-acta-nacimiento {
		display: inline-block; 
		margin-left: 10px;
	}

	.btn-upload-curp {
		display: inline; 
		margin-left: 10px;
	}

	.info-icon {
		width: 2rem;
		height: 2rem;
		margin-left: 1rem;
		transition: transform .2s;
	}

	.info-icon:hover {
		transform: scale(1.3);
	}

	@media(max-width: 1199px){
		.t1-input-curp {
			display: block; 
			max-width: 100%; 
			transform: translateY(3px);
		}

		.t1-input-dia,
		.t1-input-mes {
			width: 12%; 
		}


		.t1-input-ano {
			width: 18%; 
		}

		.btn-upload-curp {
			display: block; 
			margin-top: 10px;
			margin-left: 0px;
		}

		.btn-acta-nacimiento {
			display: block; 
			margin-left: 0px;
			margin-top: 10px;
		}
	}

	@media(max-width: 992px){
		.btn-comprobante-domicilio {
			margin-left: 0px;
			display: block;
		}

		.t1-input-dia,
		.t1-input-mes {
			width: 18%; 
		}


		.t1-input-ano {
			width: 28%; 
		}


		.t1-input-colonia {
			max-width: 100%;
			margin-bottom: 10px;
			display: block;
		} 
	}

	@media(max-width: 768px){
		.t1-input-colonia {
			max-width: 100%;
		}
	}

	@media (max-width: 576px) { 

		}
</style>
